module.exports = __webpack_public_path__ + "img/rotate-clockwise.482e618e.svg";